import { render, staticRenderFns } from "./IconVkFooter.vue?vue&type=template&id=2cf4404e&"
import script from "./IconVkFooter.vue?vue&type=script&lang=js&"
export * from "./IconVkFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf4404e')) {
      api.createRecord('2cf4404e', component.options)
    } else {
      api.reload('2cf4404e', component.options)
    }
    module.hot.accept("./IconVkFooter.vue?vue&type=template&id=2cf4404e&", function () {
      api.rerender('2cf4404e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconVkFooter.vue"
export default component.exports